document.addEventListener('keydown',(event) => {
    const prevLink = document.querySelector('a.nav-prev');
    const nextLink= document.querySelector('a.nav-next');
    const backLink = document.querySelector('a.back-to-article');
    if (event.key==='ArrowLeft' && prevLink) {
        window.location.href = prevLink.href;
    } else if (event.key==='ArrowRight' && nextLink) {
        window.location.href = nextLink.href;
    } else if (event.key==='Escape' && backLink) {
        event.preventDefault();
        window.location.href = backLink.href;
    }
});